module.exports = __webpack_public_path__ + "img/circle-info.ff2727cc.svg";